import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import React, { ChangeEvent } from 'react'

interface RadioButtonsProps {
  value: any
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  options: string[]
  label?: string
  error?: string
  layout?: 'vertical' | 'horizontal'
}

export const RadioButtons: React.FC<RadioButtonsProps> = ({
  value,
  onChange,
  options,
  label,
  error,
  layout = 'vertical',
}) => {
  const orientationStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: layout === 'horizontal' ? 'row' : 'column',
  }

  return (
    <FormControl
      error={!!error}
      size='small'
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {label && <FormLabel component='legend'>{label}</FormLabel>}
      <RadioGroup
        aria-labelledby='radio-buttons-group-label'
        name='radio-buttons-group'
        value={value}
        onChange={onChange}
        style={orientationStyle}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={<Radio />}
            label={option}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
